export default __webpack_public_path__ + "static/pilot-Mike-1fce47372f8c5a928259593762807439.png";